module.exports = __webpack_public_path__ + "static/media/IMG_7277_DxO.a990c384.jpg";